import { Mesh } from 'three';
import React from 'react';

export default {
    name: '[pipe]transitional-holender',
    prototype: 'holes',

    info: {
        tag: ['transitional-holender'],
        title: 'Transitional Holender',
        description: 'Transitional Holender',
        image: require('./transitional-holender.png')
    },

    properties: {
        width: {
            label: 'Width',
            type: 'length-measure',
            defaultValue: {
                length: 50
            }
        }
    },

    render2D: function (element, layer, scene) {

        let width = element.properties.get('width').get('length');
        return (
            <g transform={`scale(${width * 0.05} ${width * 0.05}) translate(-2, -1)`}>
                <rect x="2" y="-1" height="4" width="6" stroke="#000000" fill="#000000" />
                <rect x="0" y="0" height="2" width="10" stroke="#000000" fill="#000000" />
            </g>
        )
    },

    render3D: function (element, layer, scene) {
        let mesh = new Mesh();
        return Promise.resolve(mesh);
    }
};
